import Vue from 'vue'

const state = {
  baseUri: '/botw/config/contractComp/'
}
const getters = {
}
const actions = {
  searchDong: function (_context, [data, callback]) { // 법정동 조회
    const reqData = {
      level: data.level,
      upperDongCode: data.dongCode
    }
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'dongSearch',
      params: reqData
    }
    console.log('actions dongSearch axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  search: function (_context, [searchParam, callback]) { // 내역 조회
    const reqData = {
      contractCompName: searchParam.contractCompName,
      // dongName: searchParam.address,
      extraAddress: searchParam.address,
      dataFlag: String(searchParam.dataFlag),
      pageNum: searchParam.pageNum,
      rowCount: searchParam.rowCount
    }
    console.log('actions search : ', reqData)
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'search',
      params: reqData
    }
    console.log('actions search axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  detail: function (_context, [contractCompSeq, callback]) { // 상세 조회
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'detail/' + contractCompSeq
    }
    console.log('actions detail axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  insert: function (_context, [data, callback]) { // 등록
    const reqData = {
      contractCompName: data.contractCompName,
      businessNum: data.businessNum,
      representative: data.representative,
      mainPhoneNum: data.mainPhoneNum,
      fax: data.fax,
      email: data.email,
      dongCode: data.dongCode,
      extraAddress: data.extraAddress,
      dataFlag: String(true),
      // tbFile: data.tbFile,
      fileCode: data.tbFile.fileCode
    }
    console.log('insert data: ', reqData)
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'insert',
      data: reqData
    }
    console.log('actions insert axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  update: function (_context, [data, callback]) { // 수정
    const reqData = {
      contractCompSeq: data.contractCompSeq,
      contractCompName: data.contractCompName,
      representative: data.representative,
      mainPhoneNum: data.mainPhoneNum,
      fax: data.fax,
      email: data.email,
      dongCode: data.dongCode,
      extraAddress: data.extraAddress,
      dataFlag: String(data.dataFlag),
      // tbFile: data.tbFile,
      fileCode: data.tbFile.fileCode,
      descList: data.descList
    }
    console.log('update data : ', reqData)
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'update',
      data: reqData
    }
    console.log('actions update axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  descInsert: function (_context, [param, callback]) { // 특이사항 등록
    const reqData = {
      // insertUserSeq: param.insertUserSeq,
      contractCompSeq: param.contractCompSeq,
      desc: param.desc
    }
    console.log('descInsert reqData : ', reqData)

    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'descInsert',
      data: reqData
    }
    console.log('actions descInsert axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  descUpdate: function (_context, [param, callback]) { // 특이사항 수정
    const reqData = {
      updateUserSeq: param.updateUserSeq,
      contractCompSeq: param.contractCompSeq,
      contractCompDtlSeq: param.contractCompDtlSeq,
      desc: param.desc
    }
    console.log('descUpdate reqData : ', reqData)

    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'descUpdate',
      data: reqData
    }
    console.log('actions descUpdate axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  descDelete: function (_context, [param, callback]) { // 특이사항 삭제
    const reqData = {
      contractCompSeq: param.contractCompSeq,
      contractCompDtlSeq: param.contractCompDtlSeq
    }
    console.log('descDelete reqData : ', reqData)

    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'descDelete',
      data: reqData
    }
    console.log('actions descDelete axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  fileCodeUpdate: function (_context, [data, callback]) {
    console.log('fileCodeUpdate : ', data)
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'fileCodeUpdate',
      data: data
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  fileCodeInit: function (_context, [data, callback]) {
    console.log('fileCodeInit actions : ', data)
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'fileCodeInit',
      data: data
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  }
}
const mutations = {
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
